// Compress an image file to ≤256px square, JPEG, ≤80KB. Returns a base64 data URL
// suitable for inlining into babies.photo_data.

const MAX_DIM = 256;
const TARGET_MAX_BYTES = 80 * 1024;
const MIN_QUALITY = 0.5;

export async function compressPhoto(file: File): Promise<string> {
  const img = await loadImage(file);
  const { width, height, sx, sy, ss } = squareCrop(img.naturalWidth, img.naturalHeight);
  const canvas = document.createElement("canvas");
  const dim = Math.min(MAX_DIM, ss);
  canvas.width = dim;
  canvas.height = dim;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("canvas-unsupported");
  ctx.drawImage(img, sx, sy, ss, ss, 0, 0, dim, dim);
  void width;
  void height;

  let quality = 0.85;
  let url = canvas.toDataURL("image/jpeg", quality);
  while (url.length * 0.75 > TARGET_MAX_BYTES && quality > MIN_QUALITY) {
    quality -= 0.1;
    url = canvas.toDataURL("image/jpeg", quality);
  }
  return url;
}

function loadImage(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("image-load-failed"));
    };
    img.src = url;
  });
}

function squareCrop(w: number, h: number): { width: number; height: number; sx: number; sy: number; ss: number } {
  const ss = Math.min(w, h);
  return {
    width: w,
    height: h,
    sx: Math.floor((w - ss) / 2),
    sy: Math.floor((h - ss) / 2),
    ss,
  };
}
